<template>
  <div class="list row">
    <div class="col-md-8">
      <div class="input-group mb-3">

        <input type="text" v-mask="'###.###.###-##'" class="form-control" placeholder="Buscar por CPF do produtor"
          v-model="cpf_farmer"/>
        <div class="input-group-append">
          <button class="btn btn-outline-secondary" type="button"
            @click="page = 1; retrieveReports();"
          >
            Buscar
          </button>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="mb-3">
        Items por página:
        <select v-model="pageSize" @change="handlePageSizeChange($event)">
          <option v-for="size in pageSizes" :key="size" :value="size">
            {{ size }}
          </option>
        </select>
      </div>

      <b-pagination
        v-model="page"
        :total-rows="count"
        :per-page="pageSize"
        size="sm"
        prev-text="<"
        next-text=">"
        @change="handlePageChange"
      ></b-pagination>
    </div>


    <div class="col-md-6">
      <h5>Comunicação de Perdas (COP)</h5>
      <ul class="list-group">
        <li class="list-group-item"
          :class="{ active: index == currentIndex }"
          v-for="(report, index) in reports"
          :key="index"
          @click="setActiveReport(report, index)"
        >
          <label><strong>Produtor: </strong></label> {{ report.name_farmer }}
        </li>
      </ul>

    </div>
    <div class="col-md-6">
      <div v-if="currentReport">
        <br />
        <label><strong><u>COP selecionado</u></strong></label>
        <br />
        <router-link :to="'/reports/' + currentReport.id" class="badge badge-warning">Editar</router-link>
        <div>
          <label><strong>Nome:</strong></label> {{ currentReport.name_farmer }}
        </div>
        <div>
          <label><strong>E-mail:</strong></label> {{ currentReport.email_farmer }}
        </div>
        <div>
          <label><strong>CPF:</strong></label> {{ currentReport.cpf_farmer}}
        </div>
        <div>
          <label><strong>Latitude:</strong></label> {{ currentReport.loc_titllage_lat}}
        </div>
        <div>
          <label><strong>Longitude:</strong></label> {{ currentReport.loc_tittlage_lon}}
        </div>
        <div>
          <label><strong>Tipo da lavoura:</strong></label> {{ tillage}}
        </div>
        <div>
          <label><strong>Data da colheita:</strong></label> {{ currentReport.harvest_date}}
        </div>
        <div>
          <label><strong>Data do evento:</strong></label> {{ currentReport.event_date}}
        </div>
        <div>
          <label><strong>Evento ocorrido:</strong></label> {{ event}}          
        </div>
      <br />
      <br />
      </div>

      <div v-else>
        <br />
        <p>Clique na COP...</p>
      </div>
    </div>
  </div>
</template>

<script>
import ReportDataService from "../services/ReportDataService";
import {mask} from 'vue-the-mask';

export default {
  directives: {mask},
  name: "reports-list",
  data() {
    return {
      reports: [],
      currentReport: null,
      currentIndex: -1,
      cpf_farmer: "",

      page: 1,
      count: 0,
      pageSize: 3,
      pageSizes: [3, 6, 9],
    };
  },
  methods: {
    getRequestParams(cpf_farmer, page, pageSize) {
      let params = {};
      if (cpf_farmer) {
        params["cpf_farmer"] = cpf_farmer;
      }
      if (page) {
        params["page"] = page - 1;
      }
      if (pageSize) {
        params["size"] = pageSize;
      }
      return params;
    },

    retrieveReports() {
      const params = this.getRequestParams(
        this.cpf_farmer,
        this.page,
        this.pageSize
      );

      ReportDataService.getAll(params)
        .then(response => {
          const { reports, totalItems } = response.data;
          this.reports = reports;
          this.count = totalItems;

          console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },

    handlePageChange(value) {
      this.page = value;
      this.retrieveReports();
    },
    handlePageSizeChange(event) {
      this.pageSize = event.target.value;
      this.page = 1;
      this.retrieveReports();
    },

    refreshList() {
      this.retrieveReports();
      this.currentReport = null;
      this.currentIndex = -1;
    },

    setActiveReport(report, index) {
      this.currentReport = report;
      this.currentIndex = index;
      switch (this.currentReport.type_tillage) {
        case "MI":
          this.tillage = "MILHO";
          break;
        case "SO":
          this.tillage = "SOJA";
          break;
        case "TR":
          this.tillage = "TRIGO";
          break;
        case "FE":
          this.tillage = "FEIJÃO";
          break;
        default:
          console.log("Sem lavoura mapeada.")
      }
      switch (this.currentReport.event) {
        case "CE":
          this.event = "CHUVA EXCESSIVA";
          break;
        case "GE":
          this.event = "GEADA";
          break;
        case "GR":
          this.event = "GRANIZO";
          break;
        case "SE":
          this.event = "SECA";
          break;
        case "VE":
          this.event = "VENDAVAL";
          break;
        case "RA":
          this.event = "RAIO";
          break;
        default:
          console.log("Sem evento mapeado.")
      }
    },
    
    searchCPF() {
      ReportDataService.findByCPF(this.cpf_farmer)
        .then(response => {
          this.reports = response.data;
          console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    }
  },
  mounted() {
    this.retrieveReports();
  }
};
</script>

<style>
.list {
  text-align: left;
  max-width: 800px;
  margin: auto;
}
</style>
